import qs from 'qs';

import { client } from '../client';
import { Meta } from '../communication/types/Meta';
import { CaseIntakeQuestions, ICase } from './types/ICase';
import { ADMIN_SCOPED_ROLES } from '@brands/Utils/staffScopedApiPrefix';

export interface IListCases {
  nodes: ICase[];
  total: number;
  meta: Meta;
}

export interface IListCasesParams {
  userRoleName?: string;
  case_id?: number;
  type?: string[];
  case_type?: string[];
  status?: string | string[];
  consultation_date?: string;
  completed_date?: string;
  canceled_date?: string;
  case_state?: string[];
  patient_user_type?: string;
  client_tag?: string;
  patient_full_name?: string;
  care_advisor_full_name_filter?: string;
  provider_full_name?: string;
  payment_method?: string;
  patient_self_pay_cost?: number;
  insurance_carrier?: number[];
  limit?: number;
  sort_by?: 'created_at' | 'updated_at';
  sort_direction?: 'asc' | 'desc';
  cursor?: string;
  cursor_direction?: 'next' | 'previous';
  care_advisor_id?: number;
  collector_id?: number;
  provider_id?: number;
  patient_id?: number;
  dependent_id?: number;
  include_patient_care_advisor_conversation?: boolean;
  include_patient_provider_conversation?: boolean;
  include_provider_care_advisor_conversation?: boolean;
  include_vc_stats?: boolean;
  include_dependents_cases?: boolean;
  provider_email?: string;
  care_advisor_email?: string;
  patient_email?: string;
  follow_up_status?: string;
  consultation_date_start?: string;
  consultation_date_end?: string;
  completed_date_start?: string;
  completed_date_end?: string;
  canceled_date_start?: string;
  canceled_date_end?: string;
  created_at_start?: string;
  created_at_end?: string;
  collector_full_name?: string;
  case_intake_questions?: CaseIntakeQuestions;
}

export const listAllCases = async (params?: IListCasesParams | string): Promise<IListCases> => {
  let queryParams: Record<string, any> = {};

  if (typeof params === 'string') {
    queryParams = qs.parse(params, { ignoreQueryPrefix: true }) as Record<string, any>;
  } else if (params && typeof params === 'object') {
    queryParams = { ...params };
  }

  const { userRoleName: _userRoleName, ...rest } = queryParams;
  const baseUrl = _userRoleName && ADMIN_SCOPED_ROLES.has(_userRoleName) ? '/admin/cases' : '/cases';

  const qsPart = qs.stringify(rest, { skipNulls: true, arrayFormat: 'repeat' });
  const { data } = await client.get(qsPart ? `${baseUrl}?${qsPart}` : baseUrl);
  return data;
};
